import React from "react";
import cs from "classnames";
import PartnersSectionNew from "../../organisms/PartnersSectionNew/PartnersSectionNew";
import Logotype, { TYPES as LOGOTYPE_TYPES } from "../../atoms/Logotype";
import { APPLICATION_ROUTES } from "../../../constants";
import classes from "./PartnersPackages.module.scss";

const PartnersPackages = () => {
  return (
    <main className={cs("minh-100vh pt-10")}>
      <header className={cs("d-flex jc-center ai-center", classes.header)}>
        <Logotype
          type={LOGOTYPE_TYPES.PARTNERS}
          url={APPLICATION_ROUTES.PARTNERS_MAIN_HOME}
        />
      </header>
      <PartnersSectionNew discount={false} />
    </main>
  );
};

export default PartnersPackages;
